import { jsx as _jsx } from "react/jsx-runtime";
import { Typography } from '@coolblue-development/freddy';
import { StyledAnchorBarItemLink } from './AnchorBarItem.styles.js';
const AnchorBarItem = ({ item, onClick, isActive = false }) => {
    const { href, title, label } = item;
    return (_jsx(StyledAnchorBarItemLink, { href: href, title: title, isActive: isActive, onClick: onClick, children: _jsx(Typography, { component: "span", fontFamily: "Open Sans", children: label }) }));
};
export default AnchorBarItem;
//# sourceMappingURL=AnchorBarItem.js.map